module.exports = __webpack_public_path__ + "static/media/firebase-icon.10b07193.svg";